import svg from './row-svg/panier.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function PanierIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default PanierIcon;
